import { useQuery } from "@tanstack/react-query";
import { productsServices } from "../services/productsServices.js";
import { useState } from "react";

const ITEMS_PER_PAGE = 5;

export default function Produtos() {
  const [page, setPage] = useState(1);
  const { data, isLoading, error, isFetching } = useQuery({
    queryKey: ["produtos", page],
    queryFn: () => productsServices.getProducts({ page, limit: ITEMS_PER_PAGE }),
    keepPreviousData: true,
  });

  if (isLoading) {
    return (
      <div className="container mx-auto p-4">
        <div className="flex items-center justify-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
          <p className="ml-2">Carregando produtos...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mx-auto p-4">
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
          <p>Erro ao carregar produtos. Por favor, tente novamente.</p>
        </div>
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className="container mx-auto p-4">
        <h2 className="text-2xl font-bold mb-4">Produtos</h2>
        <p className="text-gray-600">Nenhum produto encontrado.</p>
      </div>
    );
  }

  return (
    <div className="container mx-auto p-4">
      <h2 className="text-2xl font-bold mb-4">Produtos</h2>

      {/* Lista de produtos */}
      <ul className="space-y-2 mb-4">
        {data.map((product) => (
          <li key={product.id} className="p-2 bg-white rounded shadow">
            {product.name} - R${product.price}
          </li>
        ))}
      </ul>

      {/* Indicador de carregamento */}
      {isFetching && (
        <div className="flex items-center justify-center mb-4">
          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-gray-900"></div>
          <p className="ml-2 text-sm text-gray-600">
            Carregando mais produtos...
          </p>
        </div>
      )}

      {/* Controles de paginação */}
      <div className="flex justify-center gap-2">
        <button
          onClick={() => setPage((old) => Math.max(old - 1, 1))}
          disabled={page === 1}
          className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-300 transition-colors"
        >
          Anterior
        </button>
        <span className="px-4 py-2 bg-gray-100 rounded">Página {page}</span>
        <button
          onClick={() => setPage((old) => old + 1)}
          disabled={data.length < ITEMS_PER_PAGE}
          className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-300 transition-colors"
        >
          Próxima
        </button>
      </div>
    </div>
  );
}
